import React from "react";

const Minus = ({ ...rest }) => {
    return (
        <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g id="minus">
                <path
                    id="Icon"
                    d="M4.08333 8.75H13.4167"
                    stroke="#0F1016"
                    strokeWidth="1.33"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

export default Minus;
